import {
  getExceptionsTypes,
  getProviderFormService,
} from '../../../helper';

/**
 *
 * @param {object} serviceData
 * @param {object|null} modal
 * @param {object} config
 * @description
 *
 *
 * Не показываем:
 * Для Subscription
 * Если в конфиге start_count = false
 * Если form.start_count === 0
 *
 * Если Mode === 1, проверяем service_type провайдера
 *
 * @returns {boolean}
 */
export default (serviceData, modal, config) => {
  // TODO PNL-9833
  // Разрешили Start count parsing и Auto Complete для Subscription услуг
  // const isSubscription = checkModalSubscription(modal);
  // const isProviderServiceSubscription = checkProviderServiceSubscription(serviceData?.form, serviceData?.providerForm);
  const accessAutoComplete = config?.auto_complete;
  const form = serviceData?.form;
  const providerForm = serviceData?.providerForm;
  const exceptionsTypes = getExceptionsTypes();

  if (accessAutoComplete) {
    if (form) {
      const { mode, service_type, start_count, provider_service_id } = form;
      if (start_count) {
        if (mode === 1) {
          // Если выбран провайдер, проверяем его service_type
          if (providerForm) {
            const service = getProviderFormService(provider_service_id, providerForm);
            if (service && service.hasOwnProperty('service_type')) {
              const providerServiceType = service.service_type;
              const isIncludeExceptionType = exceptionsTypes.includes(Number(providerServiceType));
              return !isIncludeExceptionType;
            }
          }
          // Показыавем всегда, если включен start_count
          return true;
        }

        if (mode === 0) {
          const isIncludeExceptionType = exceptionsTypes.includes(Number(service_type));
          return !isIncludeExceptionType;
        }
      }
    }
  }

  return false;
};
